import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@material-ui/core';

import SelectTextField from '../../../../../../Common/UI/SelectTextField';

class SelectRule extends React.Component {
    static propTypes = {
        tree: PropTypes.object.isRequired,
        field: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange (event) {
        const { tree, onChange } = this.props;
        const newTree = { ...tree };
        newTree.properties = {
            ...newTree.properties,
            [event.target.name]: event.target.value
        };
        const operator = newTree.properties?.operator;
        const values = newTree.properties?.values;
        if(operator === "==" && (values?.length > 0)) newTree['isValid'] = true;
        if(operator === "==" && (values?.length === 0)) newTree['isValid'] = false;
        if(operator === "!=" && (values?.length > 0)) newTree['isValid'] = true;
        if(operator === "!=" && (values?.length === 0)) newTree["isValid"] = false;
        onChange(newTree);
    }

    render () {
        const { tree, field } =this.props;
        return (
            <>
                <SelectTextField
                    name="operator"
                    onChange={this.handleChange}
                    value={tree.properties.operator || ''}
                    placeholder="Operator"
                    size="small"
                >
                    <MenuItem value="==">{'Equals'}</MenuItem>
                    <MenuItem value="!=">{'Not Equals'}</MenuItem>
                </SelectTextField>
                <SelectTextField
                    name="value"
                    value={tree.properties.value || ''}
                    onChange={this.handleChange}
                    placeholder={field.settings.listPlaceholder || ''}
                    size="small"
                >
                    { field.settings.listOptions.map(el => <MenuItem key={el.value} value={el.value}>{el.label || el.value}</MenuItem>) }
                </SelectTextField>
            </>
        );
    }
}

export default SelectRule;